module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/svgs/regular/address-card.svg?6de21e1a6383c68b9bb7c048ff5ddb1f";